/* Open the existing STOQ consent form; never submit or replace its signup flow. */
if (!customElements.get('aonsk-restock-trigger')) {
  customElements.define('aonsk-restock-trigger', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.findTarget = () => document.querySelector('button.restock-rocket-button-product');
      this.update = () => { this.button.hidden = !this.findTarget(); };
      this.openSignup = () => {
        const target = this.findTarget();
        if (target) target.click();
        else this.update();
      };
      this.button.addEventListener('click', this.openSignup);
      this.observer = new MutationObserver(this.update);
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.openSignup);
    }
  });
}
